import React from "react";
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  size?: "lg" | "sm";
};
export function CtaButton({
  children,
  href,
  onClick,
  className = "",
  size = "lg"
}: CtaButtonProps) {
  const sizing = size === "sm" ? "px-4 py-2.5 text-sm shadow-[0_4px_0_#1E40AF] active:shadow-[0_2px_0_#1E40AF] active:translate-y-[2px]" : "px-7 py-[18px] text-lg sm:text-[22px] shadow-[0_8px_0_#1E40AF] active:shadow-[0_4px_0_#1E40AF] active:translate-y-[4px]";
  const classes = `inline-flex items-center justify-center whitespace-nowrap rounded-xl bg-accent text-center font-bold uppercase tracking-[0.01em] text-white no-underline transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-accent-hover ${sizing} ${className}`;
  if (href) {
    return <a href={href} onClick={onClick} className={classes} data-id="element-37" data-mp="19bbbtite4f86">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} data-id="element-38" data-mp="157df1erjfgia">
      {children}
    </button>;
}